export const masterdataTypes = {
    category: 'CATEGORIA',
    officeDocument: 'DOCUMENTO_CONSULTA_DESPACHOS',
    expeditionDocument: 'DOCUMENTO_CONSULTA_EXPEDICIONES',
    sourceOffice: 'OFICINA_ORIGEN',
    targetOffice: 'OFICINA_DESTINO',
    dispatch: 'DESPACHO'
}